<template>
  <div class="card-caractProd-produto-novo">
    <g-titulo-steps
    titulo="CARACTERÍSTICAS DO PRODUTO"
    subtitulo="Informe as demais caraterísticas sobre o produto"
    :imagemEmpresa = imagemEmpresa
    />

    <g-form>
      <div class="caracteristicas-produto-conteudo espacamento-fluxos">
        <div class="caractProd-gerais">

          <div class="titulo-conteudo-detalhes"> Papel de Seda </div>
            <div class="checklist-papel-seda">
                <div class="input-checkbox">
                    <PCheckBox 
                    :binary="true" 
                    v-model="papelSeda"
                    :disabled="true" 
                    ></PCheckBox>
                    <label class="label-checkbox"> Enviar Papel de Seda </label>
                </div>
                <div class="papel-seda-medidas" v-if="papelSeda">
                    <div class="MedidaPapelSeda">
                        <PInputText
                        @keypress="camponumero"
                        v-model="medidaPapelSeda"
                        disabled
                        ></PInputText>
                    </div>
                    <div class="x-papel-seda">X</div>
                    <div class="MedidaPapelSeda2">
                        <PInputText
                        @keypress="camponumero"
                        v-model="medidaPapelSeda2"
                        disabled
                        ></PInputText>
                    </div>
                </div>
            </div>

          <div class="titulo-conteudo-detalhes"> Gerais </div>
          <div class="checklist-filtros">
            <div class="input-checkbox">
              <PCheckBox 
              :binary="true" 
              v-model="optionsgeraisFSC" 
              :disabled="true"
              ></PCheckBox>
              <label class="label-checkbox"> Cliente exige selo FSC nesse produto </label>
            </div>
            <!-- <div class="input-checkbox">
              <PCheckBox
              :binary="true" 
              v-model="optionsgeraisLeg" 
              :disabled="true"
              ></PCheckBox>
              <label class="label-checkbox"> Existe legislação ou requisito regulamentar específico </label>
            </div> -->
          </div>
              
          <div class="gerais-conteudo">
            <div class="gerais-lote-sequencia">
              <div class="gerais-lote campo-texto" v-if="this.temLote">
                <div class="titulo-conteudo-filtros"> Lote: {{loteInfoText}} <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputText 
                :class="`input-label ${(v$.loteDescricao.$invalid && submit) ? 'p-invalid' : ''}`"
                placeholder="Descrição do lote"
                v-model="loteDescricao"
                :suggestions="sugestaoLotes"
                optionLabel="nome"
                optionValue="valor"
                >
                </PInputText>
              </div>

              <div class="gerais-sequencia" v-if="this.sequenciaValue">
                <div class="grupo-sequencia campo-texto">
                  <div class="titulo-conteudo-filtros"> Sequência <strong class="asterisco-obrigatorio">*</strong></div>
                  <PInputText 
                  :class="`input-label ${(v$.sequenciaDescricao.$invalid && submit) ? 'p-invalid' : ''}`"
                  placeholder="Descrição da sequência"
                  maxlength="70"
                  v-model="sequenciaDescricao"
                  optionLabel="nome"
                  optionValue="valor"
                  >
                  </PInputText>
                </div>

                <div class="grupo-sequencia-conteudo">
                  <div class="titulo-linha">
                    <div class="titulo-grupo"> Produtos da sequência (Qtde. mínima: 2) <strong class="asterisco-obrigatorio">*</strong></div>
                    <div class="linha1 linha-separacao"></div>
                  </div>
                  <div class="tipo-nome-produto">
                    <div class="sequencia-tipo-produto">
                      <div class="titulo-conteudo-filtros"> Tipo do Produto </div>
                      <PDropDown
                      :filter="true"
                      placeholder="Selecione o tipo"
                      :options="TiposOrcamentoArray"
                      optionLabel="text"
                      optionValue="enum"
                      v-model="TipoOrcamentoEnum"
                      :disabled="true"
                      ></PDropDown>
                    </div>

                    <div class="sequencia-produto-button">
                      <div class="sequencia-produto">
                        <div class="titulo-conteudo-filtros"> Produto </div>
                        <PDropDown
                        :filter="true"
                        placeholder="Selecione o Produto"
                        emptyMessage="Pesquise o produto desejado"
                        :options="ProdutoArray"
                        optionLabel="nomeProduto"
                        optionValue="produtoId"
                        v-model="produtoId"
                        :disabled="TipoOrcamentoEnum == 0"
                        >
                          <template #option="slotProps">
                            <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                          </template>
                        </PDropDown>
                      </div>                                    

                      <div class="sequencia-adicionar-produto-desktop">
                        <g-button
                        tipo="amarelo"
                        altura = "38px"
                        largura = "40px"
                        tamanhoIcone="15px"
                        :somenteIcone="true"
                        :sombreado="false"
                        @click="adicionarProdutoAoGrid"
                        >
                          <i class="pi pi-plus"></i>
                        </g-button>                                        
                      </div>

                      <div class="sequencia-adicionar-produto-mobile">
                        <g-button
                        tipo="amarelo"
                        altura = "34px"
                        largura = "15em"
                        :somenteIcone="true"
                        :sombreado="false"
                        @click="adicionarProdutoAoGrid"
                        >
                          <i class="pi pi-plus"></i>
                        </g-button>                                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sequencia-datatable" v-if="this.sequenciaValue">
          <g-data-table
          TextoVazio="Nenhum Produto (Mínimo 2)"
          Titulo="Produtos da Sequência"
          v-on:excluir="excluir"
          :colunas="Colunas"
          :valores="InformacaoProdutosSequencia"
          :NumeroLinhas="8"
          :Filtros="Filtro"
          :Editavel="false"
          :Excluivel="true"
          ></g-data-table>
        </div>
        <div class="caractProd-observacoes">
                    <div class="titulo-conteudo-detalhes"> Observações </div>
                    <PTextArea
                    rows="5"
                    cols="40"
                    v-model="observacao"
                    ></PTextArea>
                </div> 
        <!-- <div class="caractProd-embalagem topico-embalagem">
          <div class="titulo-conteudo-detalhes"> Embalagem coletiva específica </div>
          <div class="checklist-filtros">
            <div class="input-checkbox">
              <PCheckBox
              :binary="true"                             
              v-model="informacaoFilmeEncolhivel" 
              :disabled="true"
              ></PCheckBox>
              <label class="label-checkbox"> Filme encolhível </label>
            </div>
            <div class="input-checkbox">
              <PCheckBox
              :binary="true" 
              v-model="informacaoCaixa" 
              :disabled="true"
              ></PCheckBox>
              <label class="label-checkbox"> Caixa coletiva </label>
            </div>
            <div class="input-checkbox inputs-campos-palete">
              <div class="input-checkbox">                            
                <PCheckBox
                :binary="true" 
                v-model="informacaoPalete" 
                :disabled="true"
                ></PCheckBox>
                <label class="label-checkbox"> Palete </label>
              </div>
              <div class="campos-palete">
                <div class="palete-observacao campo-texto" v-if="embalagemEspecificaPalete">
                  <div class="titulos-embalagens titulo-observacao-palete"> Observações Palete </div>
                  <PInputText
                  v-model="observacaoPalete" 
                  :disabled="true"
                  ></PInputText>
                </div>

                <div class="palete-aproveitamento input-checkbox" v-if="embalagemEspecificaPalete">
                  <PCheckBox
                  :binary="true" 
                  v-model="melhorAproveitamento" 
                  :disabled="true"
                  ></PCheckBox>
                  <label class="label-aproveitamento label-checkbox"> Melhor Aproveitamento </label>
                </div>

                <div class="palete-medidas" v-if="embalagemEspecificaPalete && !melhorAproveitamento">
                  <div class="palete-comprimento">
                    <div class="titulos-embalagens"> Comprimento (cm) <strong class="asterisco-obrigatorio">*</strong></div>
                    <PInputText
                    v-model="comprimentoPalete" 
                    :disabled="(true || melhorAproveitamento)"
                    @keypress="camponumero"
                    ></PInputText>
                  </div>

                  <div class="palete-altura" v-if="embalagemEspecificaPalete && !melhorAproveitamento">
                    <div class="titulos-embalagens"> Largura (cm) <strong class="asterisco-obrigatorio">*</strong></div>
                    <PInputText
                    v-model="larguraPalete" 
                    :disabled="(true || melhorAproveitamento)"
                    @keypress="camponumero"
                    ></PInputText>
                  </div>

                  <div class="palete-largura" v-if="embalagemEspecificaPalete && !melhorAproveitamento">
                    <div class="titulos-embalagens"> Altura (cm) <strong class="asterisco-obrigatorio">*</strong></div>
                    <PInputText
                    v-model="alturaPalete" 
                    :disabled="(true || melhorAproveitamento)"
                    @keypress="camponumero"
                    ></PInputText>
                  </div>
                </div>
              </div>
            </div>
            <div class="checkbox-outros">
              <div class="input-checkbox">
                <PCheckBox
                :binary="true"
                v-model="informacaoOutras" 
                :disabled="true"
                ></PCheckBox>
                <label class="label-checkbox"> Outros </label>
              </div>  
            </div>
          </div>
        </div>                 -->
      </div>
    </g-form>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="paginafinalizada" 
        ref="botaoContinuar"
        >
          FINALIZAR
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="voltarstep4" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>
    <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import CaracProdutoRepeticao from './CaracProdutoRepeticao.js'
export default CaracProdutoRepeticao
</script>

<style scoped>
.caractProd-observacoes { grid-area: v-bind('sequenciaValue ? "4 / 1 / 5 / 3" : "3 / 1 / 4 / 3"'); }

.x-papel-seda{
    align-items: center;
    display: flex;
    margin-left: 10px;
    margin-right: 10px;
    color: #8A8A8A;
    font-size: 15px;
    font-family: 'MontSerrat';
}
.titulo-conteudo-detalhes {
  font-size: 19px;
}

.titulo-grupo, .titulos-embalagens {
  width: 100%;
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.titulo-grupo {
  font-size: 16px;
  margin: 10px 0 2px;
}

.titulos-embalagens {
  margin: 4px 0 2px;
}
.titulo-observacao-palete {
  margin: 0px 0 2px;
}

.titulo-linha {
  display: flex;
  flex-direction: column;
}

.label-checkbox {
  font-size: 16px;
}

.campos-palete {
  padding-bottom: v-bind('embalagemEspecificaPalete ? "3px":"auto"');
}

.topico {
  margin-bottom: 50px;
}
.topico-embalagem {
  margin: 50px 0;
}

.linha1 {
  margin-top: 5px;
}

.inputs-campos-palete {
  flex-direction: column;
}

.sequencia-datatable {
  margin-top: 30px;
}


@media (min-width:310px) {
  .papel-seda-medidas{
    display: flex;
}
.sequencia-adicionar-produto-desktop {
  display: none;
}
.sequencia-adicionar-produto-mobile {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
}

@media (min-width:368px) {

}

@media (min-width: 400px) {

}

@media (min-width:500px) {
.sequencia-adicionar-produto-mobile {
  display: none;
}

.sequencia-produto-button {
  display: grid;
  grid-template-columns: minmax(4em, 11fr) 0.5fr;
  grid-template-rows: auto;
  grid-column-gap: 10px;
}

.sequencia-adicionar-produto-desktop {
  display: block;
  align-self: flex-end;
  justify-self: flex-end;
  margin-bottom: 3px;
} 
}

@media (min-width:600px) {
  .papel-seda-medidas{
    display: flex;
    margin-left: 10px;
    width: 50%;
}
.checklist-papel-seda{
    display: flex;
    width: 100%;
}
.palete-medidas {
  display: grid;
  grid-template-columns: repeat(3, minmax(2em, 1fr));
  grid-column-gap: 10px;
}
}

@media (min-width:801px) {
.campo-texto {
  max-width: 23.75em;
}

.palete-medidas {
  max-width: 36em;
  display: grid;
  grid-template-columns: repeat(3, minmax(2em, 1fr));
  grid-template-rows: auto;
  grid-column-gap: 10px;
}
.palete-comprimento { grid-area: 1 / 1 / 2 / 2}
.palete-altura { grid-area: 1 / 2 / 2 / 3; }
.palete-largura { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width:1024px) { 
.tipo-nome-produto {
    display: grid;
    grid-template-columns: minmax(4em, 1fr) minmax(4em, 2fr);
    grid-template-rows: auto;
    grid-column-gap: 20px;
}
}

@media (min-width:1281px) { 
}

@media (min-width:1400px) { 
.caracteristicas-produto-conteudo {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(v-bind('sequenciaValue ? "2" : "1"'), auto);
    grid-column-gap: 60px;
    grid-row-gap: 15px;
}

.caractProd-gerais { grid-area: 1 / 1 / 2 / 2; }
.caractProd-embalagem { grid-area: 1 / 2 / 2 / 3; }
.sequencia-datatable { grid-area: v-bind('sequenciaValue ? "2 / 1 / 3 / 3" : ""'); }

.tipo-nome-produto {
  display: grid;
  grid-template-columns: minmax(4em, 1fr);
  grid-template-rows: auto;
}

.topico-embalagem {
  margin: 0 0 50px;
}
}

@media (min-width:1500px) {
.espacamento-fluxos {
  padding: 0 10% 25px;
}
}

@media (min-width:1800px) {
.espacamento-fluxos {
  padding: 0 12% 25px;
}
}

@media (min-width:2000px) {
.espacamento-fluxos {
  padding: 0 14% 25px;
}
}
</style>
